import Select from 'react-select';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  min-height: calc(100vh - 120px);
`;

export const FieldContainer = styled.div`
  margin-top: 24px;
`;

export const HelperText = styled.span`
  color: #585765;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.2px;
`;

export const Overlay = styled.span`
  width: 50%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
  background: linear-gradient(0deg, #110d12 0%, rgba(22, 17, 23, 0) 100%);

  @media screen and (max-width: 769px) {
    width: 100%;
    background-color: black;
  }
`;

export const Input = styled.input`
  font-size: 14px;
  padding: 10px 10px 10px 0 !important;
  &::placeholder {
    color: #a7a6b3;
  }
  &:focus {
    background-color: transparent !important;
  }
  margin-top: 6px;

  /* Change Autocomplete styles in Chrome*/
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: white;
    -webkit-box-shadow: 0 0 0px 1000px #000 inset;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const MessageInput = styled.textarea`
  background-color: rgb(255, 255, 255, 0.1) !important;
  height: 150px !important;
  font-size: 14px;
  padding: 1rem 10px !important;

  &::placeholder {
    color: #a7a6b3;
  }
`;

export const Label = styled.label`
  position: relative;
  font-family: 'Eina';
  font-size: 12px;
  letter-spacing: 0.2px;
  color: white;
  font-weight: normal;

  & > *:not(style) {
    margin-top: 8px;
    display: block;
  }
`;

export const NavBar = styled.div`
  width: 100%;
  height: auto;
  z-index: 0;
  background-color: #1f1a20;
  padding: 30px 20px;

  & a {
    display: block;
  }

  @media screen and (min-width: 769px) {
    width: 50%;
    background-color: transparent;
    padding: 65px 0 65px 5%;
  }
`;

export const FormContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding: 30px 30px 100px;

  @media screen and (min-width: 769px) {
    width: 50%;
    padding: 10px 5% 100px 5%;
  }

  @media screen and (min-width: 1024px) {
    width: 50%;
    padding: 10px 10% 100px 5%;
  }
`;

export const FormButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 48px 0;
  flex-direction: column;

  @media screen and (min-width: 769px) {
    flex-direction: row;
  }

  & p {
    color: white;
    font-size: 14px;
    letter-spacing: 0.2px;
    margin-left: 24px;
    margin-top: 30px;

    @media screen and (min-width: 769px) {
      margin-top: 0;
    }
  }
`;

export const Title = styled.h1`
  font-size: 2.25rem;
`;

export const CustomSelect = styled(Select)`
  & .fc-select__indicator-separator {
    display: none;
  }

  & .fc-select__menu {
    background-color: #43424d;
    color: white;
    border-radius: 0;

    .fc-select__option {
      font-size: 14px;
      letter-spacing: 0.2px;
    }

    .fc-select__option.fc-select__option--is-selected,
    .fc-select__option.fc-select__option--is-focused {
      background-color: #8c8c9c;
    }
  }

  & .fc-select__placeholder {
    font-size: 14px;
    letter-spacing: 0.2px;
    color: #a7a6b3;
  }

  & .fc-select__single-value {
    font-size: 14px;
    font-weight: 600;
    color: white;
  }

  & .fc-select__control {
    background-color: transparent !important;
    color: white;
    border: none;
    border-bottom: 1px solid #43424d;
    border-radius: 0;
    box-shadow: none;
  }

  & .fc-select__control .fc-select__value-container {
    padding: 2px 8px 2px 0;
  }

  & .fc-select__control:hover {
    border-color: #835153;
  }

  & .fc-select__control.fc-select__control--is-focused {
    border-color: #835153;
  }

  & .fc-select__control:hover {
    box-shadow: none;
  }

  .fc-select__option.fc-select__option--is-selected,
  .fc-select__option.fc-select__option--is-focused {
    background-color: #8c8c9c;
  }
`;

export const ServicesOptions = [
  {
    label: 'CAM service for a film or series',
    value: 'cam-service-for-a-film-or-series',
  },
  {
    label: 'Royalty Management software',
    value: 'royalty-management-software',
  },
  {
    label: 'Reporting software for Producers',
    value: 'reporting-software',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const RoyaltyTypeOptions = [
  {
    label: 'Theatrical distributor',
    value: 'Theatrical distributor',
  },
  {
    label: 'VOD platform',
    value: 'VOD platform',
  },
  {
    label: 'Broadcaster',
    value: 'Broadcaster',
  },
  {
    label: 'Mini/major studio',
    value: 'Mini/major studio',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const CAMRoleOptions = [
  {
    label: 'Producer',
    value: 'Producer',
  },
  {
    label: 'Director',
    value: 'Director',
  },
  {
    label: 'Sales Agent',
    value: 'Sales Agent',
  },
  {
    label: 'Financier',
    value: 'Financier',
  },
  {
    label: 'Public Fund',
    value: 'Public Fund',
  },
  {
    label: 'Talent',
    value: 'Talent',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const currenciesOptions = [
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'CAD',
    value: 'CAD',
  },
  {
    label: 'CHF',
    value: 'CHF',
  },
  {
    label: 'ILS',
    value: 'ILS',
  },
  {
    label: 'THB',
    value: 'THB',
  },
  {
    label: 'NGN',
    value: 'NGN',
  },
  {
    label: 'CRC',
    value: 'CRC',
  },
  {
    label: 'PHP',
    value: 'PHP',
  },
  {
    label: 'PLN',
    value: 'PLN',
  },
  {
    label: 'INR',
    value: 'INR',
  },
  {
    label: 'AUD',
    value: 'AUD',
  },
  {
    label: 'RON',
    value: 'RON',
  },
  {
    label: 'HKD',
    value: 'HKD',
  },
  {
    label: 'NOK',
    value: 'NOK',
  },
  {
    label: 'DKK',
    value: 'DKK',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];
export const GermanAssociationOptions = [
  { label: 'Produzentenverband', value: 'Produzentenverband' },
  { label: 'Produzentenallianz', value: 'Produzentenallianz' },
  { label: 'Verband der deutschen Games-Branche', value: 'Verband der deutschen Games-Branche' },
  { label: 'Non-affiliated', value: 'Non-affiliated' },
];
export const TierOptions = [
  { label: 'Micro company 0 - 3 titles', value: 'Micro company 0 - 3 titles' },
  { label: 'Small company 4 - 15 titles', value: 'Small company 4 - 15 titles' },
  { label: 'Medium size company 16 - 30', value: 'Medium size company 16 - 30' },
  {
    label: 'Enterprise company - more than 30 titles',
    value: 'Enterprise company - more than 30 titles',
  },
];
